import { render } from "./workflow-progress.vue?vue&type=template&id=44c536b6"
import script from "./workflow-progress.vue?vue&type=script&lang=js"
export * from "./workflow-progress.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__